import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { IMultisiteItem, MultisiteService } from '@df/core/service/multisite';
import { DfUiModule } from '@df/ui/df-ui.module';
import { MultisiteFlagComponent } from '../flag/multisite-flag.component';
@Component({
    selector: 'multisite-simple-label',
    templateUrl: './multisite-simple-label.component.html',
    standalone: true,
    imports: [MultisiteFlagComponent, CommonModule, DfUiModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultisiteSimpleLabelComponent implements OnInit {
    protected site?: IMultisiteItem;

    @Input()
    onlyIcon: boolean = false;

    constructor(readonly multisiteService: MultisiteService) {}

    ngOnInit(): void {
        this.site = this.multisiteService.current;
    }
}
